<template>
  <div
    v-if="isInSession"
    class="relative mx-auto"
    :style="`max-width: ${hotspotDimensions.width}px; max-height: ${hotspotDimensions.height}px;`"
  >
    <div class="absolute inset-0 z-20">
      <PortalTarget name="annotations-canvas" />
    </div>
    <canvas ref="pdfCanvas" class="w-full block" :style="contentStyle" />
  </div>
  <object v-else class="w-full" :data="url" :width="width * 0.8" :height="height * 0.8" type="application/pdf">
    <iframe class="w-full" :src="url" :width="width * 0.8" :height="height * 0.8" />
  </object>
</template>

<script lang="ts" setup>
import type { DeepReadonly, PropType } from 'vue'
import type { DeckUser } from '@/entities/deck'
import { usePdfHotspot } from '@/composables/usePdfHotspot'

const emit = defineEmits(['goto:page', 'update:image-dimensions'])

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
  width: {
    type: Number,
    required: true,
  },
  height: {
    type: Number,
    required: true,
  },
  currentPdfPage: {
    type: Number,
    default: 0,
  },
  user: {
    type: Object as PropType<DeepReadonly<DeckUser>>,
    default: () => ({}),
  },
  contentStyle: {
    type: Object as PropType<Record<string, any>>,
    default: () => ({}),
  },
})

const { width, height, currentPdfPage } = toRefs(props)

const { pdfCanvas, hotspotDimensions } = usePdfHotspot({
  url: props.url,
  width,
  height,
  currentPdfPage,
  onRender(dimensions: Size) {
    emit('update:image-dimensions', { width: dimensions.width, height: dimensions.height })
  },
})

const isInSession = computed(() => props.user.deckUserType === 'controlled')
</script>
